var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import Accordion from "../Accordion";
import "../../styles/CustomizeYourCombos.css";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
;
var MAX_COMBOS = 4;
var emptyCombo = function (comboNumber) { return ({
    comboNumber: comboNumber,
    selectedSvas: [],
    monthlyValue: '',
    velocityValue: '',
    velocityUnit: 'MEGA',
}); };
var findMasterProductOfGroup = function (products, groupId) {
    return products.find(function (p) { return p.group_id === groupId && p.master; });
};
function CustomizeYourCombosStep(_a) {
    var combos = _a.combos, onChange = _a.onChange, comboSvasOptions = _a.comboSvasOptions, onNext = _a.onNext, isOpen = _a.isOpen, onToggle = _a.onToggle, _b = _a.contentSuppliersProducts, contentSuppliersProducts = _b === void 0 ? [] : _b, _c = _a.productGroups, productGroups = _c === void 0 ? [] : _c, isValid = _a.isValid;
    var _d = useState(false), isValidCombos = _d[0], setIsValidCombos = _d[1];
    useEffect(function () {
        if (combos.length === 0) {
            onChange([emptyCombo(1)]);
        }
    }, [combos.length]);
    function addCombo() {
        if (combos.length >= MAX_COMBOS)
            return;
        onChange(__spreadArray(__spreadArray([], combos, true), [emptyCombo(combos.length + 1)], false));
    }
    function removeCombo(index) {
        var updated = combos
            .filter(function (_, idx) { return idx !== index; })
            .map(function (combo, idx) { return (__assign(__assign({}, combo), { comboNumber: idx + 1 })); });
        onChange(updated);
    }
    useEffect(function () {
        var isEveryComboValid = combos.every(function (combo) {
            var _a, _b;
            return combo.selectedSvas.length > 0 &&
                ((_a = combo.monthlyValue) === null || _a === void 0 ? void 0 : _a.trim()) !== '' &&
                ((_b = combo.velocityValue) === null || _b === void 0 ? void 0 : _b.trim()) !== '';
        });
        setIsValidCombos(isEveryComboValid);
    }, [combos]);
    function toggleGroup(comboIndex, group) {
        var masterProduct = findMasterProductOfGroup(contentSuppliersProducts, group.id);
        if (!masterProduct)
            return;
        var svaId = String(masterProduct.id);
        var updatedCombos = combos.map(function (combo, idx) {
            if (idx !== comboIndex)
                return combo;
            var isSelected = combo.selectedSvas.includes(svaId);
            var updatedSvas = isSelected
                ? combo.selectedSvas.filter(function (id) { return id !== svaId; })
                : __spreadArray(__spreadArray([], combo.selectedSvas, true), [svaId], false);
            return __assign(__assign({}, combo), { selectedSvas: updatedSvas });
        });
        onChange(updatedCombos);
    }
    ;
    function handleInputChange(index, field, value) {
        var updatedCombos = combos.map(function (combo, idx) {
            var _a;
            return idx === index ? __assign(__assign({}, combo), (_a = {}, _a[field] = value, _a)) : combo;
        });
        onChange(updatedCombos);
    }
    ;
    return (_jsxs(Accordion, __assign({ title: "Personalize os seus combos", name: "combos", step: 3, isOpen: isOpen, onToggle: onToggle, isValid: isValid }, { children: [combos.map(function (combo, idx) { return (_jsxs("div", __assign({ className: "combo-section", style: { paddingTop: "20px" } }, { children: [_jsxs("div", __assign({ className: "combo-header" }, { children: [_jsxs("h4", __assign({ className: "title-combos" }, { children: ["Combo ", combo.comboNumber] })), combos.length > 1 && (_jsx("button", __assign({ type: "button", className: "combo-remove", onClick: function () { return removeCombo(idx); }, "aria-label": "Remover combo ".concat(combo.comboNumber) }, { children: _jsx(CloseIcon, { fontSize: "small" }) })))] })), _jsx("span", __assign({ className: "label-default" }, { children: "Selecione os SVA's da CeletiHub inclusos nesse plano:" })), _jsx("div", __assign({ className: "sva-grid" }, { children: productGroups.map(function (group) {
                            var masterProduct = findMasterProductOfGroup(contentSuppliersProducts, group.id);
                            if (!masterProduct)
                                return null;
                            var isSelected = combo.selectedSvas.includes(String(masterProduct.id));
                            return (_jsxs("button", __assign({ type: "button", className: "sva-option", onClick: function () { return toggleGroup(idx, group); } }, { children: [isSelected ? (_jsx(CheckBoxOutlinedIcon, { sx: { color: 'rgb(112,112, 112)' } })) : (_jsx(CheckBoxOutlineBlankOutlinedIcon, { sx: { color: 'rgb(112,112, 112)' } })), _jsx("span", { children: group.name })] }), group.id));
                        }) })), _jsxs("div", __assign({ className: "form-group", style: { paddingTop: "35px" } }, { children: [_jsx("label", __assign({ className: "label-default", htmlFor: "combo-".concat(idx, "-monthly") }, { children: "Valor Mensal:" })), _jsx("input", { id: "combo-".concat(idx, "-monthly"), type: "number", min: 0, step: 0.01, className: "input-art-generator-default", value: combo.monthlyValue || '', onChange: function (e) { return handleInputChange(idx, "monthlyValue", e.target.value); }, placeholder: "Digite o valor mensal" }), _jsx("p", __assign({ className: "file-upload-info" }, { children: "Somente n\u00FAmeros" }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "label-default", htmlFor: "combo-".concat(idx, "-velocity") }, { children: "Velocidade:" })), _jsx("input", { id: "combo-".concat(idx, "-velocity"), type: "text", className: "input-art-generator-default", value: combo.velocityValue || '', onChange: function (e) { return handleInputChange(idx, "velocityValue", e.target.value); }, placeholder: "Ex: 200" }), _jsx("div", __assign({ className: "radio-group" }, { children: ['MEGA', 'GB'].map(function (unit) {
                                    var isSelected = combo.velocityUnit === unit;
                                    return (_jsxs("button", __assign({ type: "button", className: "radio-option", onClick: function () { return handleInputChange(idx, 'velocityUnit', unit); }, style: { display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '0.5rem', background: 'none', border: 'none', font: 'inherit', color: 'inherit', padding: 0 } }, { children: [isSelected ? (_jsx(RadioButtonCheckedOutlinedIcon, { sx: { color: 'rgba(244, 150, 27, 1)' } })) : (_jsx(RadioButtonUncheckedOutlinedIcon, { sx: { color: 'rgba(102, 102, 102)' } })), _jsx("span", { children: unit })] }), unit));
                                }) }))] }))] }), combo.comboNumber)); }), combos.length < MAX_COMBOS && (_jsxs("button", __assign({ type: "button", className: "add-combo-button", onClick: addCombo }, { children: [_jsx(AddIcon, { fontSize: "small" }), " Adicionar combo"] }))), _jsx("div", __assign({ className: "step-footer" }, { children: _jsx("button", __assign({ type: "button", className: "continue-button button-with-blue-border", onClick: onNext, disabled: !isValidCombos }, { children: "Continuar" })) }))] })));
}
export default CustomizeYourCombosStep;
